module.exports = __webpack_public_path__ + "static/img/rail-text-5.129fcddc.png";